(function($){
    $(function(){  //document.ready


    $('.header_slides').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        autoplaySpeed: 1500,
        autoplay: false,
         fade: false,
    speed: 500,

    infinite: true,

        slidesToScroll: 1,

        responsive: [{
            breakpoint: 1171,
            settings: {
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 901,
            settings: {
                dots: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 571,
            settings: {
                dots: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
});
      
       jQuery(function(){
      jQuery("#bgndVideo").YTPlayer();
    });
      
       jQuery(function(){
      jQuery("#bgndVideos").vimeo_player();
    });
      
      iframe = $('#projectplayer')[0];
player = $f(iframe);
player.api('setVolume',1); //reset volume
      

    });

})(jQuery);